import * as React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import moment from '../../utilities/Moment'
import NumberFormatter from '../../utilities/NumberFormatter'
import ExpenseHelper from '../../helpers/ExpenseHelper'
import ExpenseCategoryHelper from '../../helpers/ExpenseCategoryHelper'
import { CheckIcon, Trash2Icon } from 'lucide-react'
import { Expense, Settings } from '../../types'

interface IOwnProps {
  expense: Expense
  onClick: (expense: Expense) => void
  onReviewClick: (expense: Expense) => void
  onDeleteClick: (expense: Expense) => void
  setting: Settings
}

type IProps = IOwnProps & WithTranslation

class ExpenseTicket extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props)

    this.onReviewClick = this.onReviewClick.bind(this)
    this.onDeleteClick = this.onDeleteClick.bind(this)
  }

  onReviewClick(e: React.MouseEvent) {
    e.stopPropagation()

    this.props.onReviewClick(this.props.expense)
  }

  onDeleteClick(e: React.MouseEvent) {
    e.stopPropagation()

    this.props.onDeleteClick(this.props.expense)
  }

  render() {
    const {
      expense,
      setting,
      onClick,
      t,
    } = this.props

    const expenseColor = ExpenseHelper.getColor(expense)

    return (
      <div className='expense-ticket' onClick={() => onClick(expense)}>
        <div className='expense-ticket-content' style={{ borderTopColor: expenseColor }}>
          <div className='expense-ticket-category'>
            {expense.category && ExpenseCategoryHelper.getIcon(expense.category, expenseColor)}
            {expense.category && <span>
              {expense.category.name}
            </span>}
          </div>

          <div className='expense-ticket-supplier'>
            {expense.supplier ? expense.supplier.name : '-'}
          </div>

          <div className='expense-ticket-name'>
            {expense.name}
          </div>

          <div className='expense-ticket-date'>
            {moment(expense.invoiced_on).format(setting.date_format)}
          </div>

          <div className='expense-ticket-amount'>
            {NumberFormatter.formatCurrency(expense.currency, setting.number_format, expense.net_total)}
          </div>

          <div className='expense-ticket-actions'>
            <button
              type='button'
              className='expense-ticket-action is-review'
              title={t('ExpenseTicket::Mark this expense as reviewed')}
              onClick={this.onReviewClick}
            >
              <CheckIcon size={16} />
            </button>

            <button
              type='button'
              className='expense-ticket-action is-delete'
              title={t('ExpenseTicket::Permanently delete this expense')}
              onClick={this.onDeleteClick}
            >
              <Trash2Icon size={16} />
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(ExpenseTicket)